<mat-icon>
  {{iconStatus ? 'check' : 'close'}}
</mat-icon>